import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Detail from 'src/common/components/Detail';
import { Box, Paper } from '@material-ui/core';
import { sessionsAPI } from 'src/api/modules/sessions';
import notice from 'src/common/components/Notice';

const NextSessions = () => {
	const user = useSelector((state) => state.auth.user);
	const [nextSessions, setNextSessions] = useState([]);

	useEffect(() => {
		getNextSessions(user.id);
	}, [user.id]);

	const getNextSessions = (idUser) => {
		sessionsAPI
			.getNextSessionByUser(idUser)
			.then((response) => {
				if (response.length > 0) {
					setNextSessions(response);
				}
			})
			.catch((error) => notice('Ocurrio un error', 'error'));
	};

	return (
		<Paper>
			<Box padding={3}>
				<h3>Próximas Sesiones</h3>
				{nextSessions.length > 0 ? (
					<>
						{nextSessions?.map((e) => (
							<Detail
								key={e.id}
								idSesion={e.id}
								organ={e.organoColegiado.nombre}
								sesion={e.numero_sesion}
								date={e.fecha}
								hour={e.hora}
								stylesDivider={
									e.tipo_sesion === 'E'
										? { backgroundColor: '#B51233' }
										: {}
								}
							/>
						))}
					</>
				) : (
					<div
						style={{
							fontSize: '14px',
							color: '#A1A5B6',
						}}
						className="mt-lg-4"
					>
						Por el momento no hay próximas sesiones a celebrarse.
					</div>
				)}
			</Box>
		</Paper>
	);
};

export default NextSessions;
